import { HttpRequest, HttpMethod } from "./http";

class AuthProvider extends HttpRequest {
    SignIn(params) {
        return this.request(HttpMethod.Post,`/api/auth/login`, params);
    }
    SignOut(params) {
        return this.request(HttpMethod.Post,`/api/auth/logout`, params);
    }
    ForgotPassword(params) {
        return this.request(HttpMethod.Post,`/api/auth/forgotpassword`, params);
    }
    ResetPassword(params) {
        return this.request(HttpMethod.Post,`/api/auth/resetpassword`, params);
    }
    GetProfile(params) {
        return this.request(HttpMethod.Get,`/api/v1/profile`);
    }
    ChangeProfile(params) {
        return this.request(HttpMethod.Put,`/api/v1/profile`, params);
    }
    ChangePassword(params) {
        return this.request(HttpMethod.Put,`api/v1/profile/password`, params);
    }

    // --- Backoffice staff LINE link / LINE login ---------------------------
    // Spec: docs/specs/2026-10-03-bo-staff-line-login-design.md §2.
    // The paths are exact: the two public ones live under /api/auth/ (no JWT,
    // no reCAPTCHA) and the three link ones under /api/v1/profile/ so they
    // ride the existing JWT group. `code` and `state` always travel in the
    // POST body, never in a query string, so they stay out of access logs.

    // #1 — public. `purpose` is a query param the BE validates; it only ever
    // sends "login" from here, the link flow has its own JWT route (#3).
    LineAuthorizeUrl(purpose) {
        return this.request(HttpMethod.Get, `/api/auth/line/authorize-url`, {
            purpose: purpose || "login"
        });
    }

    // #2 — public. Answers the SAME body as POST /api/auth/login.
    LineCallback(params) {
        return this.request(HttpMethod.Post, `/api/auth/line/callback`, params);
    }

    // #3 — JWT. The BE binds the state it mints to the caller's user id, so
    // this takes no arguments by design.
    LineProfileAuthorizeUrl() {
        return this.request(HttpMethod.Get, `/api/v1/profile/line/authorize-url`);
    }

    // #4 — JWT.
    LineLink(params) {
        return this.request(HttpMethod.Post, `/api/v1/profile/line/link`, params);
    }

    // #5 — JWT.
    LineUnlink() {
        return this.request(HttpMethod.Delete, `/api/v1/profile/line`);
    }
}

export default AuthProvider;
